import { useContext, useEffect, useRef } from 'react';
import ZillowMapContext from '@zillow/zillow-map-control/dist/ZillowMapContext';

type RadiusCircleProps = {
  lat: number;
  lng: number;
  radiusMiles: number;
  visible: boolean;
};

const MILES_TO_METERS = 1609.34;

export const RadiusCircle = ({ lat, lng, radiusMiles, visible }: RadiusCircleProps) => {
  const { gmap } = useContext<{ gmap: google.maps.Map }>(ZillowMapContext);
  const circleRef = useRef<google.maps.Circle | null>(null);

  useEffect(() => {
    if (!gmap || !window.google?.maps?.Circle) return;

    if (circleRef.current) {
      circleRef.current.setMap(null);
    }

    if (!visible) return;

    const circle = new google.maps.Circle({
      center: { lat, lng },
      radius: radiusMiles * MILES_TO_METERS,
      fillOpacity: 0,
      strokeColor: '#21A495',
      strokeWeight: 2,
      strokeOpacity: 0.8,
      map: gmap,
    });

    circleRef.current = circle;

    return () => {
      if (circleRef.current) {
        circleRef.current.setMap(null);
      }
    };
  }, [gmap, lat, lng, radiusMiles, visible]);

  return null;
};
